import { render, staticRenderFns } from "./VueScrollingTable.vue?vue&type=template&id=05be3e01&"
import script from "./VueScrollingTable.vue?vue&type=script&lang=js&"
export * from "./VueScrollingTable.vue?vue&type=script&lang=js&"
import style0 from "./VueScrollingTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports